import styles from './wpforms.module.css'

type WpFormFieldProps = {
    formId: number | string;
    title: string;
    required: boolean;
    id: number;
    type: 'textarea' | 'input';
    placeholder: string | null | undefined;
    error: string[] | null | undefined;
    value?: any
    classes?: {
        element?: string;
        container?: string;
    }
}

export default function WpField({ title, required, id, type, placeholder, error, value, formId, classes }: WpFormFieldProps) {
    const fieldId = `wpforms-${formId}-field_${id}`
    const fieldName = `wpforms[fields][${id}]`
    const className = `${styles["wpforms-field-medium"]} ${required ? styles["wpforms-field-required"] : ''} ${error ? styles["wpforms-error"] : ''} ${classes?.element ?? ''}`
    
    return (
        <>
            <div id={`${fieldId}-container`} data-field-id={id}
                 className={`${styles["wpforms-field"]} ${error ? styles["wpforms-error"] : ""} ${classes?.container ?? ""}`}
            >
                <label className={styles["wpforms-field-label"]} htmlFor={fieldId}>
                    {title} {required && (<span className={styles["wpforms-required-label"]}>*</span>)}
                </label>
                {type === 'input'
                    ? <input type="text" id={fieldId} name={fieldName} required={required} placeholder={placeholder ?? ""} defaultValue={value} className={className}/>
                    : <textarea id={fieldId} name={fieldName} required={required} className={className} defaultValue={value}></textarea>
                }
                {error && (<label id={`${fieldId}-error`} className={styles["wpforms-error"]} htmlFor={fieldId} dangerouslySetInnerHTML={{ __html: error.join("<br>") }}></label>)}
            </div>
        </>
    )
}